"use client";

import React from "react";
import PropTypes from "prop-types";
import CustomImage from "../../atoms/customImage";

/**
 * FreeDeliveryBanner component displays a banner for free delivery promotion.
 * It fetches banner data from CMS API and shows a skeleton loader while loading.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.isMobile - Whether the device is mobile
 * @param {Object} props.bannerData - The banner data containing image URLs
 * @returns {JSX.Element|null} The banner component or null if not visible
 */
const FreeDeliveryBanner = ({ isMobile, bannerData }) => {
  const bannerImage = isMobile ? bannerData?.mobile : bannerData;

  return (
    <div>
      <CustomImage
        src={bannerImage}
        alt={"Free Delivery Banner"}
        className="h-auto w-full object-cover"
        width={isMobile ? 120 : 75}
        height={isMobile ? 120 : 75}
        style={{
          objectFit: "cover",
        }}
      />
    </div>
  );
};

FreeDeliveryBanner.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  bannerData: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.string.isRequired]),
};

export default FreeDeliveryBanner;
